import posthog from "posthog-js/dist/module.no-external";

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY;
const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST || "https://us.i.posthog.com";
const isLocalHost = ["localhost", "127.0.0.1", "::1"].includes(window.location.hostname);

let analyticsReady = false;

export function initAnalytics() {
  if (!POSTHOG_KEY || isLocalHost) {
    return;
  }

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    defaults: "2026-01-30",
    autocapture: false,
    capture_pageview: false,
    disable_session_recording: true,
    person_profiles: "identified_only"
  });

  analyticsReady = true;
}

export function captureMarketingEvent(eventName, properties = {}) {
  if (!analyticsReady) {
    return;
  }

  posthog.capture(eventName, {
    surface: "marketing_site",
    ...properties
  });
}

export function capturePageView() {
  captureMarketingEvent("marketing page viewed", {
    page_path: window.location.pathname,
    page_title: document.title,
    referrer_host: getReferrerHost()
  });
}

function getReferrerHost() {
  if (!document.referrer) {
    return undefined;
  }

  try {
    return new URL(document.referrer).hostname;
  } catch {
    return undefined;
  }
}
